import _ from 'lodash';
import {
  GET_NOTIFICATION_LIST_SUCCESS,
  GET_FAMILY_LIST_SUCCESS,
  REMOVE_NOTIFICATION_ITEM_SUCCESS,
} from './actions';
import { CLEAR_DATA } from '../actions';

const initState = {
  notifications: [],
  families: {},
};

const notificationListReducer = (state = initState, action ) => {
  // console.log('notificationListReducer', state, action);

  const { type, payload } = action;
  switch (type) {
    case GET_NOTIFICATION_LIST_SUCCESS: {
      const { notifications } = payload;
      return {
        ...state,
        notifications,
      };
    }

    case GET_FAMILY_LIST_SUCCESS: {
      const { families } = payload;
      const obj = {};
      _.forEach(families, (family) => {
        obj[family.id] = family;
      });
      return {
        ...state,
        families: obj,
      };
    }

    case REMOVE_NOTIFICATION_ITEM_SUCCESS: {
      const { notifications } = state;
      const { notificationID } = payload;
      const updatedNotification = _.filter(
        notifications, item => item.id !== notificationID,
      );
      return {
        ...state,
        notifications: updatedNotification,
      };
    }

    case CLEAR_DATA:
      return initState;

    default:
      return state;
  }
};


export default notificationListReducer;
